import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";

import { closed } from "../../components/drawer/drawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearVehicleTypeDetails } from "./vehicletypeSlice";
import {
  createVehicleType,
  getAllActiveVehicleTypes,
  getAllVehicleType,
  getVehicleTypeByID,
  updateVehicleType,
} from "./services/vehicletype.services";
import { STATUSARRAY } from "../../_contstants/common";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import IconButton from "../../components/common/IconButton";

const CreateVehicleType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const VehicleTypeDetail = useAppSelector(
    (state) => state.vehicleType.VehicleTypeDetail
  );
  const VehicleTypeID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.vehicleType.formLoading);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);

  useEffect(() => {
    return () => {
      dispatch(clearVehicleTypeDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (VehicleTypeID) {
      dispatch(getVehicleTypeByID(VehicleTypeID));
    }
  }, [VehicleTypeID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!VehicleTypeID) {
        const insertPayload = {
          VehicleType: values.VehicleType,

          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createVehicleType(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearVehicleTypeDetails());
          if (isIndirect) {
            dispatch(getAllActiveVehicleTypes());
          } else {
            dispatch(getAllVehicleType());
          }
        }
      } else {
        const editPayload = {
          ID: VehicleTypeID,
          VehicleType: values.VehicleType,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateVehicleType(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearVehicleTypeDetails());
          dispatch(getAllVehicleType());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={VehicleTypeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="mui-drawer-header">
              <Typography.h4 className="m-0">
                {VehicleTypeID ? "Update Vehicle Type" : "Add Vehicle Type"}
              </Typography.h4>
              <IconButton
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="VehicleType"
                label="Vehicle Type"
                placeholder="i.e. car"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="IsActive"
                label="Status"
                component={FormSelectionField}
                astrike={true}
                validator={requiredValidator}
                placeholder="i.e. Active"
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status?.value,
                    label: status?.label,
                  };
                })}
              />
            </GridLayoutItem>

            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={VehicleTypeID ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 10 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateVehicleType;
